<template>
  <div class="serviceCertificate">
    <div class="clear">
      <h2 class="paging-title">服务站认证</h2>
    </div>
    <div class="form">
      <ul class="step-list">
        <li v-for="(item,index) in steps" :key="index" :class="{on:index<=current-2}">
          <div class="num"><i>{{index+1}}</i></div>
          <span class="text">{{item}}</span>
        </li>
      </ul>
      <ServiceAuth v-show="current==2" :isEdit="isEdit" @stepChange="stepChange" />
      <CertificateTag v-show="current==3" :isEdit="isEdit" @stepChange="stepChange" />
      <Achievement v-show="current==4" :isEdit="isEdit" @stepChange="stepChange" />
    </div>
  </div>
</template>
<script>
import CertificateTag from '@/components/certificateTag'
import ServiceAuth from '@/components/serviceAuth'
import Achievement from '@/components/achievement'
import {p_origin} from '@/scripts/util.js'
import {mapState} from 'vuex'
import { 
  GetServiceSiteAuthInfo,
} from '@/scripts/api.js'
export default {
  name:'serviceCertificate',
  components:{
    Achievement,
    ServiceAuth,
    CertificateTag
  },
  data(){
    return{
      homeUrl:p_origin,
      steps:['基本信息','认证标签','证书及项目'],
      current:2,
      companyId:'',
      isEdit:true,
    }
  },
  computed: {
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  watch: {
    userInfo:{
      handler(value){
        if(value && value.LoginAccountId){
          this.companyId=value.LoginAccountId;
          this.getEditInfo();
        }
      },
      deep:true,
      immediate:true,
    }
  },
  created(){
    this.getEditInfo();
  },
  methods: {
    stepChange(step){
      this.current=step;
    },
    //获取服务站信息
    getEditInfo(){
      GetServiceSiteAuthInfo({
        CompanyId:this.companyId,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          let data={
            ...r.Data
          }
          if(!data.ComAccountCertList){
            data.ComAccountCertList=[];
          }
          if(!data.ComIndustryList){
            data.ComIndustryList=[];
          }
          if(!data.ComUserEngineerList){
            data.ComUserEngineerList=[];
          }
          if(!data.ExpectCityList){
            data.ExpectCityList=[];
          }
          if(!data.ProductBrandTagList){
            data.ProductBrandTagList=[];
          }
          if(!data.ServiceStageTagList){
            data.ServiceStageTagList=[];
          }
          if(!data.SuccessfulCaseList){
            data.SuccessfulCaseList=[];
          }
          this.$store.commit('setServiceInfo',data);
        }
      })
    },
  },
}
</script>
<style lang="scss">
.serviceCertificate{
  .paging-title{
    font-size: 18px;
    line-height: 24px;
    color: #f75959;
    margin-bottom: 20px;
    &:before{
      content:'';
      display: inline-block;
      width: 2px;
      height: 20px;
      background-color: #f75959;
      vertical-align: middle;
      margin-top: -3px;
      margin-right: 16px;
    }
  }
  .form{
    background-color: #F9F9F9;
    padding-top: 34px;
    padding-bottom: 45px;
    padding-left: 10px;
  }
  .step-list{
    overflow: hidden;
    margin-bottom: 40px;
    margin-left: 100px;
    li{
      width: 20%;
      float: left;
      position: relative;
      &:before{
        content: "";
        position: absolute;
        left: 0;
        top: 20px;
        width: 100%;
        height: 4px;
        border-radius: 4px;
        background-color: #d2d2d2;
      }
      .num{
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: linear-gradient(0deg, rgba(214, 214, 214, 0.7), rgba(222, 222, 222, 0.7));
        margin: 0 auto;
        position: relative;
        i{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          font-family: arial;
          display: block;
          line-height: 34px;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          text-align: center;
          background-color: #c9c9c9;
        }
      }
      .text{
        display: block;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-top: 12px;
        text-align: center;
      }
      &.on{
        &:before{
          background-color: #FF5908;
        }
        .num{
          i{
            background-color: #FF5908;
          }
        }
        .text{
          color:#FF5908;
        }
      }
    }
  }
  .form-item{
    margin-bottom: 20px;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .label{
    float: left;
    min-width: 100px;
    height: 38px;
    margin-right: 20px;
    font-size: 14px;
    color: #666;
    line-height: 38px;
  }
  .input-box{
    float: left;
    min-width: 500px;
    position: relative;
  }
  .input{
    display: block;
    width: 100%;
    height: 38px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .textarea{
    display: block;
    width: 100%;
    height: 100px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    resize: none;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .btn-code{
    position: absolute;
    right: 0;
    top: 0;
    width: 120px;
    height: 38px;
    background-color: #D5D5D5;
    color: #666;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
  .btn-default{
    float: none;
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 36px;
    background-color: #fff;
    border: 1px solid #f75959;
    border-radius: 2px;
    color: #f75959;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    margin-left: 0;
  }
  .btn-primary{
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background-color: #f75959;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
  
  .agree-deal{
    font-size: 14px;
    .el-checkbox__input{
      vertical-align: middle;
    }
    .el-checkbox__original{
      display: none;
    }
    &.is-checked{
      .el-checkbox__inner{
         background-color: #409eff;
        border-color: #409eff;
        &:after{
          content: "";
          width: 3px;
          height: 7px;
          border-right: 1px solid #fff;
          border-bottom: 1px solid #fff;
          position: absolute;
          left: 4px;
          top: 1px;
          z-index: 2;
          transform: rotate(45deg);
          // transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
          // transform-origin: center;
          box-sizing: content-box;
        }
      }
    }
    .el-checkbox__inner{
      display: inline-block;
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      box-sizing: border-box;
      width: 16px;
      height: 16px;
      background-color: #fff;
      z-index: 1;
      transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
      
    }
    .agree{
      color: #333;
      padding-left: 6px;
    }
    .deal{
      color: #f75959;
    }
  }
}

</style>